/* eslint-disable */
// src/layouts/visitMachine/strategies/PrizeStrategy.js

/* File: src/layouts/visitMachine/strategies/<tipo>Strategy.js
 * Estrategia concreta (Tragamoneda/Pool-Tejo/Rockola/Peluchera).
 * Implementa calculate(...) para producir moneyIn/Out, netos y collected.
 * No toca la UI; sólo devuelve números/flags que luego muestra el builder.
 */

import { calculateFormula } from "layouts/visitMachine/strategies/calculateFormula";
import { resolveProfitPercentage } from "./resolveProfitPercentage";

export class PrizeStrategy {
  calculate(machine, userInputs, visitMachineDetails, profitPercentages, isEditMode, prevRecords) {
    const keyId = Number(machine?.LocalMachineId ?? machine?.Id);
    
    const original = isEditMode
      ? prevRecords.find((r) => Number(r.LocalMachineId) === keyId)
      : null;
    
    const rawActualFichas = userInputs[keyId]?.CreditsIn;
    const rawCantidadPremios = userInputs[keyId]?.CreditsOut;
    const rawPrecioPremio = userInputs[keyId]?.netCreditsOut;

    const hasActualFichas =
      rawActualFichas !== null && rawActualFichas !== undefined && rawActualFichas !== "";
    const hasCantidadPremios =
      rawCantidadPremios !== null && rawCantidadPremios !== undefined && rawCantidadPremios !== "";
    const hasPrecioPremio =
      rawPrecioPremio !== null && rawPrecioPremio !== undefined && rawPrecioPremio !== "";

    const actualFichas = hasActualFichas ? Number(rawActualFichas) : null;

    const formula =
   machine?.Formula
   ?? (machine?.FormulaType != null
       ? { Type: machine.FormulaType, Value: Number(machine.FormulaValue ?? 0) }
       : null);

    const cantidadPremios = hasCantidadPremios ? Number(rawCantidadPremios) : null;
    const precioPremio = hasPrecioPremio ? Number(rawPrecioPremio) : null;

    const moneyIn = hasActualFichas
      ? (formula ? calculateFormula(actualFichas, formula) : actualFichas)
      : null;
    const moneyOut = hasCantidadPremios && hasPrecioPremio
      ? cantidadPremios * precioPremio
      : null;
    const moneyCollected =
      moneyIn != null && moneyOut != null
        ? moneyIn - moneyOut
        : null;

    const profit = resolveProfitPercentage(machine, profitPercentages, isEditMode);
    const clientAmount = moneyCollected != null
      ? (moneyCollected * (profit.ClientPercentage || 0)) / 100
      : null;
    const ownerAmount  = moneyCollected != null
      ? (moneyCollected * (profit.OwnerPercentage || 0)) / 100
      : null;

    const localMachineProfitPercentageId = profit.Id ?? null;
    
    return {
        ...machine,
        LastVisitMachineId: original?.LastVisitMachineId ?? machine?.LastVisitMachineId ?? null,
        LocalMachineId: original?.LocalMachineId || keyId,
        MachineTypeId: machine.MachineType?.Id ?? machine?.MachineTypeId ?? null,
        FormulaId: machine.Formula?.Id ?? machine?.FormulaId ?? null,
        actualCreditsIn: actualFichas,
        actualCreditsOut: cantidadPremios,
        netCreditsIn: null,
        netCreditsOut: precioPremio,
        creditsCollected: null,
        moneyIn,
        moneyOut,
        moneyCollected,
        clientAmount,
        ownerAmount,
        note: userInputs[keyId]?.Note || "",
        LocalMachineProfitPercentageId: localMachineProfitPercentageId,
    };
  }
}
